import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/image/avatar_developer_400x400.jpg")